export default "__VITE_ASSET__BDRkcsu8__"